class Exception extends Error {
  constructor(statusCode, message, jsonBody) {
    super(message)
    this.statusCode = statusCode
    this.jsonBody = jsonBody
  }
}

export default Exception
